import React from 'react';
import { NavLink} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchHomes } from '../../../../Redux/Actions/HomeActions';
import { Alert } from 'reactstrap';
import { resetPurchaseMessage } from '../../../../Redux/Actions/EndUser/StoreActions';


class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          homeScreen: true
        }

    }

    componentDidMount() {
      this.setState({        
        homeScreen: true
      })
    }

    componentWillUnmount() {
        // resetPurchaseMessage()
        this.props.store.showMessage = undefined;
    }

    render() {
        return (
            <div className="homeContainer">
                <Alert
                    color="success"
                    isOpen={typeof (this.props.store.showMessage) !== "undefined" && this.props.store.showMessage}
                    style={{ position: 'fixed', width: '100%' }}
                >
                    { this.props.store.message }
                </Alert>
                
                <div className="homeWelcomeContent">
                    <div>
                        <h1>Welcome to the TSCRA Member Center!</h1>
                        <h2>Now you can easily manage your membership online:</h2>
                        <ul>
                          <li>Access member benefits</li>
                          <li>Pay membership dues and sign up for auto renewal</li>
                          <li>View the online version of The Cattleman magazine</li>
                          <li>Update membership information</li>
                        </ul>
                        
                        <div className="container-fluid">
                            <div>
                                <div className="col-md-8 col-lg-6 col-full">
                                  <h3>Current Member?</h3>
                                  <p>Current member but new to the Member Center?</p>
                                  <NavLink tag={RouterNavLink} className="homeBtn btnPrimary" to="/existingmember">Register Now</NavLink>
                                  <hr />
                                  <p>Current member and already signed up for online access?</p>
                                  <NavLink tag={RouterNavLink} className="homeBtn btnPrimary" to="/login">Login Now</NavLink>
                                </div>
                            </div>
                        </div>
                        
                        <div className="container-fluid">
                            <div>
                                <div className="col-md-8 col-lg-6 col-full">
                                  <h3>Not a Member?</h3>
                                  <p>Joining TSCRA gives you benefits and privileges you won't find anywhere else. Our member benefits package was crafted with ranch life in mind.</p>
                                  <NavLink tag={RouterNavLink} className="homeBtn btnPrimary" to="/accountcreate">Join Now</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        home: state.home,
        store: state.store
    }
}

export default connect(mapStateToProps, { fetchHomes })(Home);